import { render, staticRenderFns } from "./CertsCheck.vue?vue&type=template&id=2a649619&scoped=true"
import script from "./CertsCheck.vue?vue&type=script&lang=js"
export * from "./CertsCheck.vue?vue&type=script&lang=js"
import style0 from "./CertsCheck.vue?vue&type=style&index=0&id=2a649619&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a649619",
  null
  
)

export default component.exports